import {Rule} from '../../models/svg-rule/rule.model';
import {IRuleSystem} from '../../models/svg-rule/rule-system.model';
import {Color} from '../../enums/color';
import {TcddTrainTabUtil, ValueIndex} from '../../utils/tcdd-train-tab-util';
import {TcddMainSystem} from '../../enums/tcdd-main-system.enum';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';
import {TcddSubSystemType} from '../../enums/tcdd-sub-system-type.enum';
import {TractionSystemKeys} from '../../constants/tcdd-system-keys/traction-system-keys';
import {TRACTION_SYSTEM} from '../../constants/tcdd-system-contants/traction-system.contant';
import {TCDD_UNIT} from '../../constants/tcdd-unit-constant';
import {createColorRule} from '../../utils/tcdd-rule-util';

function getIndex(key: string): ValueIndex {
  return TcddTrainTabUtil.getValueIndex(
    TcddMainSystem.DIAGNOSTIC_SYSTEM,
    TcddSubSystem.TRACTION_SYSTEM,
    TcddSubSystemType.SUB,
    key
  );
}

export class TractionSystemRules implements IRuleSystem {
  public getRules(): Rule[] {
    return [
      createColorRule(TCDD_UNIT.CESUR, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.TRACTION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const tempTrcIn1: ValueIndex = getIndex(TractionSystemKeys.tempTrcIn1); // >85 will be red
        const tempTrcIn2: ValueIndex = getIndex(TractionSystemKeys.tempTrcIn2); // >85 will be red
        const tempTrcRec: ValueIndex = getIndex(TractionSystemKeys.tempTrcRec); // >85 will be red
        const sInvAx3: ValueIndex = getIndex(TractionSystemKeys.sInvAx3); // === 0 will be red
        const sInvAx4: ValueIndex = getIndex(TractionSystemKeys.sInvAx4); // === 0 will be red
        const sTractionRectifierL1Ok: ValueIndex = getIndex(TractionSystemKeys.sTractionRectifierL1Ok); // === 0 will be red
        const sTractionRectifierL2Ok: ValueIndex = getIndex(TractionSystemKeys.sTractionRectifierL2Ok); // === 0 will be red
        const isolationMonitoringFault: ValueIndex = getIndex(TractionSystemKeys.isolationMonitoringFault); // === 1 will be red
        const failureTcu: ValueIndex = getIndex(TractionSystemKeys.failureTcu); // === 1 will be red
        const lcuOk: ValueIndex = getIndex(TractionSystemKeys.lcuOk); // === 0 will be red

        if ( // Red state
          Number(wagonData[tempTrcIn1.groupIndex]?.[tempTrcIn1.infoIndex]) > TRACTION_SYSTEM.TRC_TEMP_HIGH ||
          Number(wagonData[tempTrcIn2.groupIndex]?.[tempTrcIn2.infoIndex]) > TRACTION_SYSTEM.TRC_TEMP_HIGH ||
          Number(wagonData[tempTrcRec.groupIndex]?.[tempTrcRec.infoIndex]) > TRACTION_SYSTEM.TRC_TEMP_HIGH ||
          Number(wagonData[sInvAx3.groupIndex]?.[sInvAx3.infoIndex]) === TRACTION_SYSTEM.STATUS.INVERTER_FAULT ||
          Number(wagonData[sInvAx4.groupIndex]?.[sInvAx4.infoIndex]) === TRACTION_SYSTEM.STATUS.INVERTER_FAULT ||
          Number(wagonData[sTractionRectifierL1Ok.groupIndex]?.[sTractionRectifierL1Ok.infoIndex]) === TRACTION_SYSTEM.STATUS.RECTIFIER_FAULT ||
          Number(wagonData[sTractionRectifierL2Ok.groupIndex]?.[sTractionRectifierL2Ok.infoIndex]) === TRACTION_SYSTEM.STATUS.RECTIFIER_FAULT ||
          Number(wagonData[isolationMonitoringFault.groupIndex]?.[isolationMonitoringFault.infoIndex]) === TRACTION_SYSTEM.STATUS.ISOLATION_MONITOR_FAULT ||
          Number(wagonData[failureTcu.groupIndex]?.[failureTcu.infoIndex]) === TRACTION_SYSTEM.STATUS.TCU_FAULT ||
          Number(wagonData[lcuOk.groupIndex]?.[lcuOk.infoIndex]) === TRACTION_SYSTEM.STATUS.LCU_FAULT
        ) {
          setColor(Color.Red);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.CER_MOTOR, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.TRACTION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const tempMotorAx3: ValueIndex = getIndex(TractionSystemKeys.tempMotorAx3); // >140 will be red
        const tempMotorAx4: ValueIndex = getIndex(TractionSystemKeys.tempMotorAx4); // >140 will be red
        const sMotorAx3: ValueIndex = getIndex(TractionSystemKeys.sMotorAx3); // === 0 will be red
        const sMotorAx4: ValueIndex = getIndex(TractionSystemKeys.sMotorAx4); // === 0 will be red
        const motor1CoolingFault: ValueIndex = getIndex(TractionSystemKeys.motor1CoolingFault); // === 1 will be red
        const motor2CoolingFault: ValueIndex = getIndex(TractionSystemKeys.motor2CoolingFault); // === 1 will be red

        if ( // Red state
          Number(wagonData[tempMotorAx3.groupIndex]?.[tempMotorAx3.infoIndex]) > TRACTION_SYSTEM.MOTOR_TEMP_HIGH ||
          Number(wagonData[tempMotorAx4.groupIndex]?.[tempMotorAx4.infoIndex]) > TRACTION_SYSTEM.MOTOR_TEMP_HIGH ||
          Number(wagonData[sMotorAx3.groupIndex]?.[sMotorAx3.infoIndex]) === TRACTION_SYSTEM.STATUS.MOTOR_FAULT ||
          Number(wagonData[sMotorAx4.groupIndex]?.[sMotorAx4.infoIndex]) === TRACTION_SYSTEM.STATUS.MOTOR_FAULT ||
          Number(wagonData[motor1CoolingFault.groupIndex]?.[motor1CoolingFault.infoIndex]) === TRACTION_SYSTEM.STATUS.COOLING_FAULT_INACTIVE ||
          Number(wagonData[motor2CoolingFault.groupIndex]?.[motor2CoolingFault.infoIndex]) === TRACTION_SYSTEM.STATUS.COOLING_FAULT_INACTIVE
        ) {
          setColor(Color.Red);
          return true;
        }

        return false;
      })
    ];
  }
}
